import { render } from "./InitView.vue.ts?vue&type=template&id=339cebe7&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=template&id=339cebe7&ts=true"
import script from "./InitView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=script&lang=ts"
export * from "./InitView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/core-app-onboarding/views/InitView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "339cebe7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('339cebe7', __exports__)) {
    api.reload('339cebe7', __exports__)
  }
  
  module.hot.accept("./InitView.vue.ts?vue&type=template&id=339cebe7&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=template&id=339cebe7&ts=true", () => {
    api.rerender('339cebe7', render)
  })

}


export default __exports__